import { request } from 'tools'

export const getUser     = id => request.get( `users/${id}` )
export const getSelfUser = () => request.get( `users` )
export const getCards    = () => request.get( `cards` )
export const getTags     = () => request.get( `tags` )
export const getRoles    = () => request.get( `corporate/company_user_roles` )
export const getContacts = () => request.get( `contacts` )